export const ASAAS = 1
